import { useState, useEffect } from 'react'

/**
 * SSR 호환 미디어 쿼리 훅.
 *
 * SSR에서는 window가 없어 항상 false 반환.
 * 클라이언트도 첫 렌더는 false로 시작 → 하이드레이션 매치.
 * useEffect로 mount 후 실제 값으로 업데이트.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const media = window.matchMedia(query)
    setMatches(media.matches)
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches)
    media.addEventListener('change', listener)
    return () => media.removeEventListener('change', listener)
  }, [query])

  return matches
}

export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)')
}
